import { FC, ReactNode } from 'react';
import { themeColors, themeSizes } from '../../../styles/globalStyleVars';
import styled from 'styled-components';
import IconShadow from '../../../assets/celebration-shadow.svg';
import { TypographyStyled } from '../../Styled/Typography';
import { PageLoader as CorePageLoader } from '@cfa/react-core';

interface Props {
  showLoadingSpinner?: boolean;
  heading?: string;
  subheading?: string;
  description?: string | ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
}

const AlertsEmptyState = styled.div<{ $showLoadingSpinner: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0;
  min-height: 100%;
  padding: ${themeSizes.xl};

  > div {
    display: flex;
    flex-direction: column;
    margin-bottom: ${themeSizes.md};
    align-items: center;
  }

  svg {
    height: ${themeSizes.xl};
    width: ${themeSizes.xl};
    color: ${themeColors.colorGray_6};
  }
`;

const IconShadowImage = styled.img`
  margin-top: ${themeSizes.sm};
  width: 62px;
  height: auto;
  padding: 0;
`;

export const AlertsDrawerEmptyState: FC<Props> = ({
  showLoadingSpinner = false,
  heading,
  subheading,
  description,
  icon,
  children,
}) => (
  <AlertsEmptyState $showLoadingSpinner={showLoadingSpinner}>
    {showLoadingSpinner ? (
      <CorePageLoader size='sm' />
    ) : (
      icon && (
        <div>
          {icon}
          <IconShadowImage src={IconShadow} />
        </div>
      )
    )}
    <TypographyStyled
      text={heading}
      variant={showLoadingSpinner ? 'h3' : 'h4'}
      color={themeColors.colorGray_6}
    />

    {subheading && (
      <TypographyStyled
        text={subheading}
        style={{ marginBottom: themeSizes.xl, marginTop: themeSizes.sm }}
        color={themeColors.colorGray_7}
        fontWeight='medium'
      />
    )}
    {description && (
      <TypographyStyled
        text={description as string}
        style={{
          marginTop: themeSizes.sm,
          marginBottom: themeSizes.xl,
        }}
      />
    )}
    {children}
  </AlertsEmptyState>
);
